import axios from '../axios'
import URL from '@/_url_'
import qs from 'qs'

import analysis from './analysis'

let lang = localStorage.lang;

export default {
    state: {
        islogin: false, // 是否登录
        company: {}, // 用户公司信息
        user_info: {}, // 用户个人信息
        character_id: null, // 用户角色
        power: [], // 用户权限

        page: {
            current_page: 1,
            last_page: 1,
            per_page: 1, // 每页数据
            total: 1 // 总计多少数据
        }, //页码参数
		page2: {
		    current_page: 1,
		    last_page: 1,
		    per_page: 1, // 每页数据
		    total: 1 // 总计多少数据
		}, //管理用户参数
        // 
        // ************* 首页管理 ****************
        // 
        main_info: { // 首页管理顶部参数
            user: {},
            company: {},
            order: {
                cart: null,
                collection: null,
                order: null,
                quote: null,
				mine_order:null,
				other_order:null
            }
        },
        order_num: {}, // 首页订单数量
        // 
        // ************* 管理分公司/分行 ****************
        //
        branch_list: [], // 分公司/分行列表
        branch_detail: {}, // 分公司/分行详情
        parent_company: [], // 所属公司选项
        // 
        // ************* 收货地址管理 ****************
        //
        address_list: [], // 收货地址列表
        address_detail: {}, // 收货地址详情
        // 
        // ************* 管理部门 ****************
        //
        department_list: [], // 部门列表
        department_detail: {}, // 部门详情
        // 
        // ************* 管理用户 ****************
        //
        member_list: [], // 成员列表
        member_detail: {}, //成员详情
        character_list: [], // 角色列表
        jurisdiction: [], // 跨部门列表
        examine_list: [], // 审批人列表
        // 
        // ************* 资料修改 ****************
        //
        user_data: {}, // 用户资料
        email_list: [], // 邮箱列表
        // 
        // ************* 订单状态 ****************
        // 
        order_department: [], // 部门信息
        // 
        // ************* 月结单 ****************
        // 
        statement: [],
    },
    getters: {
        powerPrice: (state) => {
            return !state.islogin || state.power.includes(8) || state.power.includes(0) || state.power.includes(111)
        }
    },
    mutations: {
		// 页数
        setPage(state, {current_page = 1, last_page = 1, per_page = 1,  total = 1 }) {
            state.page = {
                current_page,
                last_page,
                per_page,
                total
            };
			// console.log("查看", state.page)
        },
		// 页数管理用户
		setPage2(state, {current_page = 1, last_page = 1, per_page = 1,  total = 1 }) {
		    state.page2 = {
		        current_page,
		        last_page,
		        per_page,
		        total
		    };
			// console.log("查看", state.page2)
		},
        // 
        // ************* 登录 ****************
        //
        setLogin(state, arg){ // 写入登录用户信息
            let { company, userinfo, power } = arg;
            state.islogin = true
            state.company = company;
            state.user_info = userinfo;
            state.character_id = userinfo.character_id;
            state.power = power;
			console.log(state.character_id,1)
        },
		setLogin2(state, arg){ // 写入登录用户信息
			if(arg){
				state.power = arg;
			}else{
				state.power = [];
			}
			console.log(state.power,2)
			// console.log('查看状态',arg,state.power)
		},
        setSessionLogin(state, arg){
            let { company, user_info, power, islogin } = arg;
            state.islogin = islogin
            state.company = company;
            state.user_info = user_info;
            state.character_id = user_info.character_id;
            state.power = power;
			// console.log(state.power,3)
        },
        clearLogin(state){ // 注销清空用户信息
            state.islogin = false;
            state.company = [];
            state.user_info = [];
            state.power = [];
        },
        // 
        // ************* 首页管理 ****************
        // 
        setCenterMainInfo(state, arg){ // 写入首页管理个人信息
		    // console.log(arg)
            state.main_info = {
                user: arg.user,
                company: arg.company,
                order: {
                    cart: arg.cart,
                    collection: arg.collection,
                    order: arg.order,
                    quote: arg.quote,
					mine_order:arg.mine_order,
					other_order:arg.other_order,
				
                }
            }
        },
        handleChangeAvatar(state, arg){
            state.main_info.user.avatar = arg
        },
        setCenterMainOrder(state, arg){
            state.order_num = arg;
        },
        clearCenterMain(state){ // 清空首页管理个人信息
            state.main_info = {
                user: {},
                company: {},
                order: {
                    cart: null,
                    collection: null,
                    order: null,
                    quote: null
                }
            }
            state.order_num = {};
        },
        // 
        // ************* 管理分公司/分行 ****************
        //
        setBranchList(state, arg){ // 写入分公司/分行列表
            for(let val of arg){
                if(!val.parentname){
                    val.parentname=val.companyname;
                }
            }
            state.branch_list = arg;
        },
        setBranchDetail(state, arg){ // 写入分公司/分行详情
            state.branch_detail = arg;
			// console.log("查看", state.branch_detail)
        },
        setBranchParent(state, arg){ // 写入所属公司选项
            state.parent_company = arg;
        },
        // 
        // ************* 收货地址管理 ****************
        //
        setAddressList(state, arg){
            state.address_list = arg;
			console.log(11, state.address_list)
        },
        setAddressDetail(state, arg){
            state.address_detail = arg;
        },
        // 
        // ************* 管理部门 ****************
        //
        setDepartmentList(state, arg = []){ // 写入部门列表
            for(let val of arg){
                if(!val.parentname){
                    val.parentname=val.companyname;
                }
            }
            state.department_list = arg;
        },
        setDepartmentDetail(state, arg){ // 写入部门详情
            state.department_detail = arg;
        },
        setDepartmentParent(state, arg = []){ // 写入所属公司选项
            state.parent_company = arg;
        },
        // 
        // ************* 管理用户 ****************
        //
        setMemberList(state, arg){ // 写入成员列表
            state.member_list = arg;
        },
        setMemberDetail(state, arg){ // 写入成员详情
            arg.member.address = arg.address;
            arg.member.powers = arg.power;
            arg.member.flow = arg.flow;
            arg.member.flow_id = arg.flow_id;
            arg.member.jurisdiction = arg.jurisdiction;
            state.member_detail = arg.member;
        },
        setCharacter(state, arg){ // 写入角色列表
            state.character_list = arg;
        },
        setMemberCompany(state, arg){ // 写入所属公司列表
            state.parent_company = arg;
        },
        setMemberDepartment(state, arg){ // 写入所属部门列表
            arg.unshift({
                departmentname: "",
                department_id: ""
            })
            state.department_list = arg;
        },
        setJurisdiction(state, arg = []){ // 写入跨部门列表
            // 添加nodeKey，方便树形菜单设置（必须）
            arg.map((branch, bIndex) => {
                branch.nodeKey = bIndex.toString()
                branch.department.map((dep, dIndex) => {
                    dep.nodeKey = `${bIndex}-${dIndex}`;
                })
            })
            let jur = [{
                branchname: '全部',
                branch_id: 'all',
                nodeKey: 'all',
                department: arg
            }]
            state.jurisdiction = jur;
        },
        setMemberExamine(state, arg){ // 写入审批人列表
            state.examine_list = arg;
        },
        // 
        // ************* 资料修改 ****************
        //
        setUserData(state, arg){ // 写入用户资料
            state.user_data = arg;
        },
        setCompanyEmail(state, arg){ // 写入公司邮箱
            state.email_list = arg;
        },
        // 
        // ************* 订单状态 ****************
        // 
        setOrderDepartment(state, arg){
            state.order_department = arg;
        },
        // 
        // ************* 月结单 ****************
        // 
        setStatement(state, arg){
            state.statement = arg;
        }
    },
    actions: {
		//
		// ************* 刷新权限状态 ****************
		//
		refreshJurisdiction(state,setLogin2){ 
		    return new Promise((resolve, reject) => {
		       let url = "/index/member/power";
		        axios({
		            method: "GET",
		            url,
		            
		        }).then((res) => {
					setLogin2(state,res.data.power);
		      
		        }).catch(err => {
		        })
		    })
		},
        
        // ************* 登录 & 注册 ****************
        //
        sendLogin({ state, commit, dispatch }, arg){ // 登录请求
            if(state.islogin) return;
            commit("handleLoading", true);
            return new Promise((resolve, reject) => {
                let { uname: username, pwd: password } = arg,
                data = qs.stringify({
                    username,
                    password
                }),
                url = "/index/login/login";
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        commit("setLogin", res.data);
                        dispatch("getCart"); // 获取购物车
                        dispatch("getQuoteCart"); // 获取报价车
                        resolve({
                            islogin: true
                        });
                    }else{
                        resolve({
                            islogin:false,
                            msg: res.data.msg
                        });
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`登录请求接口异常：${err}，请联系管理员`);
                })
            })
        },
        sendSignOut({commit}){ // 注销请求
            commit("handleLoading", true);
            return new Promise((resolve) => {
                let url = "/index/login/quit";
                axios.post(url).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        commit("clearLogin");
                        resolve(true)
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`登出请求接口异常：${err}，请联系管理员`);
                })
            })
        },
        sendForget({ commit }, arg){ // 忘记密码请求
            commit("handleLoading", true);
            let { username, email } = arg,
            url = "/index/login/forget",
            data = qs.stringify({
                username,
                email
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve({
                            type: true
                        })
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.msg
                        })
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`忘记密码接口异常：${err}，请联系管理员`);
                })
            })
        },
        sendRegister({ state, commit }, arg){ // 注册请求
            if(state.islogin) return;
            commit("handleLoading", true);
            return new Promise((resolve) => {
                let url = "", data = {};
                // 判断注册用户类型
                if(!!arg.companyname){ // 公司用户
                    let { username, companyname, en_companyname, password, email, consignee, mobile, fax, address, area, industry, market, license } = arg
                    url = "/index/Register/company";
                    data = qs.stringify({
                        username,
                        password,
                        companyname,
                        en_companyname,
                        email,
                        consignee,
                        mobile,
                        fax,
                        address,
                        area,
                        industry,
                        market,
                        license
                    })
                }else{ // 个人用户
                    let { username, password, email, consignee, mobile, address } = arg;
                    url = "/index/register/person";
                    data = qs.stringify({
                        username,
                        password,
                        email,
                        consignee,
                        mobile,
                        address
                    })
                }
                // 发起请求
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve({
                            isRegister: true
                        })
                    }else{
                        resolve({
                            isRegister: false,
                            msg: res.data.msg
                        })
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`注册请求接口异常：${err}，请联系管理员`);
                })
            })
        },
        handleValidateUname({}, arg){ // 用户名验证
            let url = "/index/register/check_user",
            data = qs.stringify({
                username: arg
            });
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    resolve(res.data)
                }).catch(() => {})
            })
        },
        // 
        // ************* 首页管理 ****************
        // 
        getCenterMainInfo({ state, commit }){ // 获取首页管理个人信息
            return new Promise((resolve) => {
                if(state.islogin){
                    let url = "/index/information/information?lang=" + lang;
                    axios.get(url).then((res) => {
                        if(res.data.code == 1){
                            commit("setCenterMainInfo", res.data);
                            resolve(true);
                        }
                    }).catch(() => {})
                }
            })
        },
        getCenterMainOrder({ state, commit }){ // 获取首页管理订单数量
            return new Promise((resolve) => {
                if(state.islogin){
                    let url = "/index/information/order";
                    axios.get(url).then((res) => {
                        if(res.data.code == 1){
                            commit("setCenterMainOrder", res.data);
                            resolve(true);
                        }
                    }).catch(() => {})
                } 
            })
        },
        // 
        // ************* 管理分公司/分行 ****************
        //
        getBranchList({ state, commit }, arg){ // 获取分行/子公司列表
            commit("handleLoading", true);
            let {
                    search = '',
                    attr = '',
                    mode = '',
                    page = 1
                } = arg,
                islogin = state.islogin,
                company_id = state.user_info.company_id,
                url = `/index/branch/branch_list?lang=${lang}&company_id=${company_id}&search=${search}&sortAttr=${attr}&sortMode=${mode}&page=${page}`;
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setBranchList", res.data.branch);
                        commit('setPage', res.data.page);
                    }
                }).catch(err => {
                    alert(`获取分行/子公司列表接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
            }
        },
        getBranchDetail({ commit }, arg){ // 获取分行/子公司详情
            commit("handleLoading", true);
            let url = "/index/branch/edit?branch_id="+arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setBranchDetail", res.data.branch);
                    commit("setBalance", res.data.balance);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                alert(`获取分行/子公司详情接口异常：${err}，请联系管理员`);
            }).finally(() => {
                commit('handleLoading', false);
            })
        },
        getBranchParent({ state, commit }, arg){ // 获取母公司参数
            commit("setBranchParent", []);
            let islogin = state.islogin,
            company_id = state.user_info.company_id,
            url = "/index/branch/parent?lang="+lang+"&company_id="+company_id;
            if(!!arg){
                url += "&branch_id="+arg;
            }
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setBranchParent", res.data.branch);
                    }
                }).catch(() => {})
            }
        },
        handleDelBranch({ commit }, arg){ // 删除分行/子公司
            commit("handleLoading", true);
            let url = "/index/branch/delete",
            data = qs.stringify({
                branch_id: arg
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
					resolve(res.data)
                }).catch(err => {
                    alert(`删除分行/子公司接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
            })
        },
        handleAddBranch({ state, commit }, arg){ // 添加 & 修改分行/子公司
            commit("handleLoading", true);
            let { parent_id, parentname, branch_id = "", branch_code, branchname, en_branchname, principal, phone, email, address, fax, amount, url = "/index/branch/add" } = arg,
            data = qs.stringify({
                parent_id,
                parentname,
                branch_id,
                branch_code,
                branchname,
                en_branchname,
                principal,
                phone,
                email,
                address,
                fax,
                amount
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
					resolve(res.data)
                }).catch(err => {
                    alert(`添加&修改分行/子公司接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
            })
        },
        // 
        // ************* 收货地址管理 ****************
        //
        getAddressList({ state, commit }, arg){ // 获取收货地址列表
            commit("handleLoading", true);
			let all = arg.all||'';
            let { 
                search = '',
                attr = '',
                mode = '',
                page = 1 } = arg,
                islogin = state.islogin,
                url = `/index/address/address?lang=${lang}&search=${search}&sortAttr=${attr}&sortMode=${mode}&page=${page}&limit=${all}`;
            if(islogin){
              let a = axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setAddressList", res.data.address);
                        commit('setPage', res.data.page);
						return true
                    }
					
                }).catch(err => {
                    alert(`获取收货地址接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
				return a
				
            }
			
        },
        getAddressDetail({ commit }, arg){ // 获取收货地址详情
            commit("handleLoading", true);
            let url = "/index/address/edit?address_id="+arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setAddressDetail", res.data.address);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                alert(`获取收货地址详情接口异常：${err}，请联系管理员`);
            }).finally(() => {
                commit('handleLoading', false);
            })
        },
        handleDelAddress({ commit }, arg){ // 删除收货地址
            commit("handleLoading", true);
            let url = "/index/address/delete",
            data = qs.stringify({
                address_id: arg
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                }).catch(err => {
                    alert(`删除收货地址接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
            })
        },
        handleAddAddress({ commit }, arg){ // 添加 & 修改收货地址
            commit("handleLoading", true);
            let { address_id, consignee, address = "", mobile, email, fax, status, url = "/index/address/add" } = arg,
            data = qs.stringify({
                address_id,
                consignee,
                address,
                mobile,
                email,
                fax,
                status,
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve(true);
                    }else{
                        resolve(false);
                    }
                }).catch(err => {
                    alert(`添加 & 修改收货地址接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
            })
        },
        // 
        // ************* 管理部门 ****************
        //
        getDepartmentList({ state, commit }, arg){ // 获取部门列表
            commit("handleLoading", true);
            let { 
                search = '',
                attr = '',
                mode = '',
                page = 1 } = arg,
                islogin = state.islogin,
                company_id = state.user_info.company_id,
                url = `/index/department/department_list?lang=${lang}&company_id=${company_id}&search=${search}&sortAttr=${attr}&sortMode=${mode}&page=${page}`;
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setDepartmentList", res.data.department);
                        commit('setPage', res.data.page);
                    }
                }).catch(err => {
                    alert(`获取部门列表接口异常：${err}，请联系管理员`);
                }).finally(() => {commit('handleLoading', false)})
            }
        },
        getDepartmentDetail({ commit }, arg){ // 获取部门详情
            commit("setDepartmentDetail", {});
            commit("handleLoading", true);
            let url = "/index/department/edit?department_id="+arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setDepartmentDetail", res.data.department);
                    commit("setBalance", res.data.balance);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                alert(`获取部门详情接口异常：${err}，请联系管理员`);
            }).finally(() => {commit('handleLoading', false)})
        },
        getDepartmentParent({ state, commit }){ // 获取母公司参数
            let islogin = state.islogin,
                company_id = state.user_info.company_id,
                branch_id = state.user_info.branch_id,
                url = `/index/department/parent?lang=${lang}&company_id=${company_id}&branch_id=${branch_id}`;
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setDepartmentParent", res.data.branch);
                    }
                }).catch(() => {})
            }
        },
        handleDelDepartment({ commit }, arg){ // 删除部门
            commit("handleLoading", true);
            let url = "/index/department/delete",
            data = qs.stringify({
                department_id: arg
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve(true)
                    }else{
                        resolve(false)
                    }
                }).catch(err => {
                    alert(`删除部门接口异常：${err}，请联系管理员`);
                }).finally(() => {commit('handleLoading', false)})
            })
        },
        handleAddDepartment({ commit }, arg){ // 添加 & 修改部门
            commit("handleLoading", true);
            let { department_id, branch_id, department_code, departmentname, en_departmentname, principal, phone, email, amount, url = "/index/department/add" } = arg,
            data = qs.stringify({
                department_id,
                branch_id,
                department_code,
                departmentname,
                en_departmentname,
                email,
                principal,
                phone,
                amount
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve(true);
                    }else if(res.data.code == 3){
                        resolve(false);
                    }
                }).catch(err => {
                    alert(`添加&修改部门接口异常：${err}，请联系管理员`);
                }).finally(() => {commit('handleLoading', false)})
            })
        },
        // 
        // ************* 管理用户 ****************
        //
        getMemberList({ state, commit }, arg){ // 获取成员列表
            commit("handleLoading", true);
            let { 
                search = '',
                attr = '',
                mode = '',
                page = 1 } = arg,
                company_id = state.user_info.company_id,
                url = `/index/member/member?lang=${lang}&company_id=${company_id}&search=${search}&sortAttr=${attr}&sortMode=${mode}&page=${page}`;
            axios.get(url)
            .then(res => {
                if(res.data.code == 1){
                    commit("setMemberList", res.data.member);
                    commit('setPage2', res.data.page);
                }
            }).catch(err => {
                alert(`获取用户列表接口异常：${err}，请联系管理员`);
            }).finally(() => {commit('handleLoading', false)})
        },
        getMemberDetail({ commit }, arg){ // 获取成员详情
            commit("handleLoading", true);
            let url = "/index/member/edit?user_id=" + arg;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setMemberDetail", res.data);
                    commit("setBalance", res.data.balance);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                alert(`获取成员详情接口异常：${err}，请联系管理员`);
            }).finally(() => {commit('handleLoading', false)})
        },
        handleDelMember({ dispatch, commit }, arg){ // 删除成员
            commit("handleLoading", true);
            let url = "/index/member/delete",
                data = qs.stringify({
                    user_id: arg
                })
            return new Promise((resolve,reject) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve(true)
                    }
					if(res.data.code == 2){
						resolve(false)
					    // alert(`有未审批订单或报价单，无法删除用户`);
					}
                }).catch(err => {
                    alert(`删除成员接口异常：${err}，请联系管理员`);
                }).finally(() => {commit('handleLoading', false)})
            })
        },
		exportQuotationCarOrder({ commit },arg) {
			console.log(arg)
		    commit('handleLoading', true);
		    // let url = '/index/Information/user_download?lang='+lang;
			let  url = `/index/quoteorder/quote_excel?lang=${lang}&quote_id=${arg.id}`;
		    return new Promise((resolve) => {
		        axios.get(url)
		        .then((res) => {
		            resolve(res.data)	
		        }).catch(err => {
		            alert(`下载订单汇总excel接口异常：${err}，请联系管理员`);
		        }).finally(() => {
		            commit('handleLoading', false);
		        })
		    })
		},
        exportMemberExcel({ commit },arg) {
			console.log(arg)
            commit('handleLoading', true);
            // let url = '/index/Information/user_download?lang='+lang;
			let  url = `/index/Information/user_download_csv?lang=${lang}&id=${arg.id}`;
            return new Promise((resolve) => {
                axios.get(url)
                .then((res) => {
                    resolve(res.data)	
                }).catch(err => {
                    alert(`下载订单汇总excel接口异常：${err}，请联系管理员`);
                }).finally(() => {
                    commit('handleLoading', false);
                })
            })
        },
        getCharacter({ commit }){ // 获取角色列表
            let url = "/index/member/character?lang=" + lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setCharacter", res.data.character);
                }
            }).catch(() => {})
        },
        getMemberCompany({ state, commit }){ // 获取所属公司列表
            let company_id = state.user_info.company_id,
            url = `/index/member/parent?lang=${lang}&company_id=${company_id}`;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setMemberCompany", res.data.branch)
                }
            }).catch(() => {})
        },
        getMemberDepartment({ state, commit }, arg){ // 获取所属部门列表
            let company_id = state.user_info.company_id,
                branch_id = arg || "",
                url = `/index/member/department_list?lang=${lang}&company_id=${company_id}&branch_id=${branch_id}`;
            axios.get(url).then((res) => {
                commit("setMemberDepartment", res.data.department);
            }).catch(() => {})
        },
        getJurisdiction({ state, commit }){ // 获取跨部门列表
            let company_id = state.user_info.company_id,
            url = `/index/member/jurisdiction2?lang=${lang}&company_id=${company_id}`;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setJurisdiction", res.data.branch)
                }
            }).catch(() => {})
        },
        getMemberExamine({ state, commit }, arg){ // 获取审批人列表
            let { character_id, branch_id, department_id, user_id = "" } = arg,
            company_id = state.user_info.company_id,
            url = "/index/member/examine",
            data = qs.stringify({
                company_id,
                character_id,
                branch_id,
                department_id,
                user_id
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    commit("setMemberExamine", res.data.examine)
                }
            }).catch(() => {})
        },
        handleAddMember({ state, commit }, arg){ // 添加成员
            commit("handleLoading", true);
            let { 
				personal_sn,
                character_id, 
                user_id, 
                username, 
                password, 
                email, 
                truename, 
                market, 
                branch_id, 
                department_id, 
                powers, 
                address,
                quote_status, 
                jurisdiction,
                flow, 
                approval_amount, 
                limit_amount, 
				limit_min_amount,
                monthly_amount, 
                accumulative_type,
				order_status
            } = arg,
            url = "/index/member/add";
            let data = qs.stringify({
				personal_sn,
                character_id,
                user_id,
                username,
                password,
                email,
                truename,
                market,
                branch_id,
                department_id,
                powers,
                address,
                quote_status,
                jurisdiction,
                flow,
                approval_amount,
                limit_amount,
				limit_min_amount,
                monthly_amount,
                accumulative_type,
				order_status
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve({
                            type: 1
                        })
                    }else if(res.data.code == 4){
                        resolve({
                            type: 4,
                        })
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.msg
                        })
                    }
                }).catch(() => {
                }).finally(() => {commit('handleLoading', false)})
            })
        },
        handleModifyMember({ state, commit }, arg){ // 修改成员
			console.log(arg)
            commit("handleLoading", true);
            let { 
				personal_sn,
                user_id,
                password, 
                email, 
                truename, 
                market, 
                branch_id, 
                department_id, 
                powers, 
                address, 
                quote_status,
                jurisdiction,
                flow, 
                flow_id = "", 
                approval_amount, 
                limit_amount, 
				limit_min_amount,
                monthly_amount, 
				order_status,
                accumulative_type 
            } = arg,
            id = state.member_detail.id,
            url = "/index/member/editpost";
            let data = qs.stringify({
				personal_sn,
                id,
                user_id,
                password,
                email,
                truename,
                market,
                branch_id,
                department_id,
                powers,
                address,
                quote_status,
                jurisdiction,
                flow,
                flow_id,
                approval_amount,
                limit_amount,
				limit_min_amount,
                monthly_amount,
                accumulative_type,
				order_status,
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        resolve({
                            type: 1
                        })
                    }else if(res.data.code == 4){
                        resolve({
                            type: 4,
                        })
                    }else{
                        resolve({
                            type: false,
                            msg: res.data.msg
                        })
                    }
                }).catch(err => {
                    alert(`修改成员接口异常：${err}，请联系管理员`);
                }).finally(() => {commit('handleLoading', false)})
            })
        },
        // 
        // ************* 资料修改 ****************
        //
        getCompanyData({ state, commit }){ // 获取公司用户信息
            commit("setUserData", {})
            commit("handleLoading", true);
            let islogin = state.islogin,
            url = "/index/company/company?lang="+lang;
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setUserData", res.data.company);
                        commit("handleLoading", false);
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`获取公司用户接口异常：${err}，请联系管理员`);
                })
            }
        },
        handleModifyCompany({ commit }, arg){ // 公司用户修改资料
            commit("handleLoading", true);
            let { company_id, companyname, en_companyname, email, tel, phone, principal, address, fax, area, industry, market, license, amount } = arg,
            url = "/index/company/editpost",
            data = qs.stringify({
                company_id,
                companyname,
                en_companyname,
                email,
                tel,
                phone,
                principal,
                address,
                fax,
                area,
                industry,
                market,
                license,
                amount
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve({
                            type: true,
                        });
                    }else if(res.data.code == 2){
                        resolve({
                            type: false,
                            msg: res.data.msg
                        });
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`公司用户修改资料接口异常：${err}，请联系管理员`);
                })
            })
        },
        getCompanyEmail({ commit }){ // 获取公司用户邮箱
            commit("setCompanyEmail", []);
            commit("handleLoading", true);
            let url = "/index/company/email_list?lang="+lang;
            axios.get(url).then((res) => {
                if(res.data.code == 1){
                    commit("setCompanyEmail", res.data.email);
                    commit("handleLoading", false);
                    commit("handleDialog", true);
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`获取公司用户邮箱接口异常：${err}，请联系管理员`);
            })
        },
        handleChangeEmail({ commit, dispatch }, arg){ // 修改邮箱
            commit("handleLoading", true);
            let { id, email = false, status } = arg,
            url = "/index/company/email_edit",
            data = qs.stringify({
                id,
                status
            })
            if(email){
                data = qs.stringify({
                    id,
                    email,
                    status
                })
            }
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    if(res.data.code == 1){
                        dispatch("getCompanyEmail")
                        resolve(true);
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`修改邮箱接口异常：${err}，请联系管理员`);
                })
            })
        },
        handleAddEmail({ dispatch, commit }, arg){ // 添加邮箱
            commit("handleLoading", true);
            let { email, status } = arg,
            url = "index/company/email_add",
            data = qs.stringify({
                email,
                status
            })
            axios({
                method: "POST",
                url,
                data
            }).then((res) => {
                if(res.data.code == 1){
                    dispatch("getCompanyEmail")
                }
            }).catch(err => {
                commit("handleLoading", false);
                alert(`添加邮箱接口异常：${err}，请联系管理员`);
            })
        },
        handleDelEmail({ commit }, arg){ // 删除邮箱
            commit("handleLoading", true);
            let url = "/index/company/email_delete",
            data = qs.stringify({
                id: arg
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve({
                            type: true
                        })
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`删除邮箱接口异常：${err}，请联系管理员`);
                })
            })
        },
        getPersonalData({ state, commit }){ // 获取个人用户信息
            commit("setUserData", {})
            commit("handleLoading", true);
            let islogin = state.islogin,
            url = "/index/company/personal?lang="+lang;
            if(islogin){
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setUserData", res.data.user);
                        commit("handleLoading", false);
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`获取个人用户信息接口异常：${err}，请联系管理员`);
                })
            }
        },
        handleModifyPersonal({ commit }, arg){ // 个人用户修改资料
            commit("handleLoading", true);
            let { id, user_id, username, truename, nickname, email, mobile, fax } = arg,
            url = "/index/company/personal_edit",
            data = qs.stringify({
                id,
                user_id,
                username,
                truename,
                nickname,
                email,
                mobile,
                fax,
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve(true);
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`个人用户资料修改接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ************* 密码修改 ****************
        // 
        handleModifyPwd({ commit }, arg){
            commit("handleLoading", true);
            let { oldpassword, newpassword } = arg,
            url = "/index/password/cooperation",
            data = qs.stringify({
                oldpassword,
                newpassword
            })
            return new Promise((resolve) => {
                axios({
                    method: "POST",
                    url,
                    data
                }).then((res) => {
                    commit("handleLoading", false);
                    if(res.data.code == 1){
                        resolve(true);
                    }else if(res.data.code==2){
                        resolve(false);
                    }
                }).catch(err => {
                    commit("handleLoading", false);
                    alert(`密码修改接口异常：${err}，请联系管理员`);
                })
            })
        },
        // 
        // ************* 订单状态 ****************
        // 
        getOrderDepartment({ state, commit }){
            if(state.islogin){
                let id = state.user_info.company_id,
                url = "/index/orderstatus/member?lang="+lang+"&company_id="+id;
                axios.get(url).then((res) => {
                    if(res.data.code == 1){
                        commit("setOrderDepartment", res.data.department)
                    }
                }).catch(() => {})
            }
        },
        // 
        // ************* 月结单 ****************
        // 
        getStatement({ state, commit }, arg){
            commit('setStatement', []);
            commit('handleLoading', true);
            let { 
                release = '', 
                relend = '',
                attr: sortAttr = '',
                mode: sortMode = '',
                page = 1
            } = arg,
                islogin = state.islogin,
                url = '/index/month/order',
                data = qs.stringify({
                    release,
                    relend,
                    sortAttr,
                    sortMode,
                    page
                })
            if(islogin){
                axios({
                    method: 'POST',
                    url,
                    data,
                }).then((res) => {
                    commit('setStatement', res.data.order);
                    commit('setPage', res.data.page);
                }).catch(err => {
                    alert(`月结单列表接口异常：${err}，请联系管理员`);
                }).finally(() => {commit('handleLoading', false)})
            }
        }
    },
    modules: {
        analysis
    },
}